<template>
  <form ref="profile_form" @submit.prevent="handleSubmit">
    <!-- Organization -->
    <base-input
      :label="`${$t('COMMON.ORGANIZATION')} (*)`"
      :placeholder="$t('COMMON.ORGANIZATION')"
      v-if="
        $currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS) &&
        !hideOrganization
      "
    >
      <organization-selector
        :organization="cafeteria.organization.id"
        :filterable="true"
        :showAll="false"
        @organizationChanged="
          (organizationId) => {
            cafeteria.organization.id = organizationId;
            cafeteria.establishment.id = null;
            onFormChanged();
          }
        "
        :disabled="!!cafeteria.id"
      />
    </base-input>
    <validation-error :errors="apiValidationErrors.organization" />

    <!-- establishment -->
    <div class="row" v-if="cafeteria.organization.id != null">
      <div class="col">
        <base-input
          :label="`${$t('COMMON.ESTABLISHMENT')} (*)`"
          :placeholder="$t('COMMON.ESTABLISHMENT')"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_ESTABLISHMENTS)"
        >
          <establishment-selector :onlyActive="true"
            :establishment="cafeteria.establishment?.id"
            :filterable="true"
            :showAll="false"
            :filterOrganization="cafeteria.organization.id"
            @establishmentChanged="
              (establishmentId) => {
                cafeteria.establishment.id = establishmentId;
                onFormChanged();
              }
            "
          />
        </base-input>
        <validation-error :errors="apiValidationErrors.establishment" />
      </div>
    </div>

    <div class="row">
      <div class="col">
        <base-input
          :label="`${$t('COMMON.NAME')} (*)`"
          :required="true"
          v-model="cafeteria.name"
          @change="
            () => {
              onFormChanged();
            }
          "
        />
        <validation-error :errors="apiValidationErrors.name" />
      </div>
    </div>
<!-- 
    <div class="row">
      <div class="col">
        <base-input
          :label="`${$t('CAFETERIAS.SERVICE_TYPE')} (*)`"
          :placeholder="$t('CAFETERIAS.SERVICE_TYPE')"
          @change="
            () => {
              onFormChanged();
            }
          "
        >
          <el-select
            :name="`${$t('CAFETERIAS.SERVICE_TYPE')}`"
            :placeholder="$t('CAFETERIAS.SERVICE_TYPE')"
            v-model="cafeteria.service_type"
          >
            <el-option
              v-for="(service, key) in SERVICE_TYPES"
              :key="key"
              :value="service"
              :label="$t('CAFETERIAS.SERVICE_TYPE_' + service)"
            />
          </el-select>
        </base-input>
        <validation-error :errors="apiValidationErrors.service_type" />
      </div>
    </div> -->

    <div class="row">
      <div class="col">
        <base-input
          :label="`${$t('CAFETERIAS.OPERATION_TYPE')} (*)`"
          :placeholder="$t('CAFETERIAS.OPERATION_TYPE')"
          @change="
            () => {
              onFormChanged();
            }
          "
        >
          <el-select
            :name="`${$t('CAFETERIAS.OPERATION_TYPE')}`"
            :placeholder="$t('CAFETERIAS.OPERATION_TYPE')"
            v-model="cafeteria.operation_type"
            @change="cafeteriaOperationChange"
          >
            <el-option
              v-for="(operation, key) in OPERATION_TYPES"
              :key="key"
              :value="operation"
              :label="$t('CAFETERIAS.OPERATION_TYPE_' + operation)"
            />
          </el-select>
        </base-input>
        <validation-error :errors="apiValidationErrors.operation_type" />
      </div>
    </div>

    <div
      class="row"
      v-if="cafeteria.operation_type === OPERATION_TYPE_SATELLITE"
    >
      <div class="col">
        <base-input
          :label="`${$t('CAFETERIAS.RELATED_PRODUCTION_CAFETERIA')} (*)`"
          :placeholder="$t('CAFETERIAS.RELATED_PRODUCTION_CAFETERIA')"
          @change="
            () => {
              onFormChanged();
            }
          "
        >
          <cafeteria-selector
            :filterable="true"
            :showAll="false"
            :filterOperationType="OPERATION_TYPE_PRODUCTION"
            :filterOrganization="cafeteria.organization.id"
            :cafeteria="cafeteria?.productionCafeteria?.id"
            @cafeteriaChanged="
              (cafeteriaSelected) => {
                cafeteria.productionCafeteria.id = cafeteriaSelected;
                onFormChanged();
              }
            "
          />
        </base-input>
        <validation-error :errors="apiValidationErrors.productionCafeteria" />
      </div>
    </div>

    <div
      class="row"
      v-if="cafeteria.operation_type === OPERATION_TYPE_PRODUCTION"
    >
      <div class="col-12">
        <h4 class="form-control-label mt-2">
          {{ $t("CAFETERIAS.INTERNAL_ORDER_DISCOUNT") }}
        </h4>
        <small class="text-muted d-block mb-2">
          {{ $t("CAFETERIAS.INTERNAL_ORDER_DISCOUNT_HELP") }}
        </small>
      </div>
      <div class="col-md-4">
        <base-input :label="$t('CAFETERIAS.INTERNAL_ORDER_DISCOUNT_TYPE')">
          <el-select
            v-model="internalOrderDiscount.type"
            @change="internalOrderDiscountChanged"
          >
            <el-option
              v-for="type in DISCOUNT_TYPES"
              :key="type"
              :value="type"
              :label="$t('CAFETERIAS.INTERNAL_ORDER_DISCOUNT_TYPE_' + type)"
            />
          </el-select>
        </base-input>
      </div>
      <div class="col-md-4">
        <base-input
          :label="
            internalOrderDiscount.type === DISCOUNT_TYPE_PERCENTAGE
              ? $t('CAFETERIAS.INTERNAL_ORDER_DISCOUNT_VALUE_PERCENTAGE')
              : $t('CAFETERIAS.INTERNAL_ORDER_DISCOUNT_VALUE_AMOUNT')
          "
          type="number"
          min="0"
          step="0.01"
          v-model="internalOrderDiscount.value"
          @input="internalOrderDiscountChanged"
        />
      </div>
      <div class="col-md-4">
        <base-input
          :label="$t('CAFETERIAS.INTERNAL_ORDER_DISCOUNT_NAME')"
          :placeholder="$t('CAFETERIAS.INTERNAL_ORDER_DISCOUNT_NAME_PLACEHOLDER')"
          v-model="internalOrderDiscount.name"
          @input="internalOrderDiscountChanged"
        />
      </div>
      <div class="col-12">
        <validation-error
          :errors="apiValidationErrors.internal_order_discounts"
        />
      </div>
    </div>

    <div class="row">
      <div class="col">
        <base-input
          :label="`${$t('CAFETERIAS.ORDER_TYPE')} (*)`"
          :placeholder="$t('CAFETERIAS.ORDER_TYPE')"
          @change="
            () => {
              onFormChanged();
            }
          "
        >
          <el-select
            :name="`${$t('CAFETERIAS.ORDER_TYPE')}`"
            :placeholder="$t('CAFETERIAS.ORDER_TYPE')"
            v-model="cafeteria.order_type"
            @change="orderTypeChanged"
          >
            <el-option
              v-for="(orderType, key) in ORDER_TYPES"
              :key="key"
              :value="orderType"
              :label="$t('CAFETERIAS.ORDER_TYPE_' + orderType)"
            />
          </el-select>
        </base-input>
        <validation-error :errors="apiValidationErrors.order_type" />
      </div>
    </div>

    <!-- Conditional service options for counter order -->
    <div class="row" v-if="cafeteria.order_type === ORDER_TYPE_COUNTER">
      <div class="col">
        <base-input
          :label="`${$t('CAFETERIAS.SERVICE_OPTIONS')} (*)`"
          :placeholder="$t('CAFETERIAS.SERVICE_OPTIONS')"
          @change="
            () => {
              onFormChanged();
            }
          "
        >
          <el-select
            :name="`${$t('CAFETERIAS.SERVICE_OPTIONS')}`"
            :placeholder="$t('CAFETERIAS.SERVICE_OPTIONS')"
            v-model="cafeteria.service_options"
            multiple
            filterable
          >
            <el-option
              v-for="(serviceOption, key) in COUNTER_SERVICE_TYPES"
              :key="key"
              :value="serviceOption"
              :label="$t('CAFETERIAS.SERVICE_OPTION_' + serviceOption)"
            />
          </el-select>
        </base-input>
        <validation-error :errors="apiValidationErrors.service_options" />
      </div>
    </div>

    <!-- Detail text for the "Autre" (OTHER) service option -->
    <div
      class="row"
      v-if="
        cafeteria.order_type === ORDER_TYPE_COUNTER &&
        cafeteria.service_options &&
        cafeteria.service_options.includes(SERVICE_OTHER)
      "
    >
      <div class="col">
        <base-input
          :label="$t('CAFETERIAS.SERVICE_OPTION_OTHER_DETAIL')"
          :placeholder="$t('CAFETERIAS.SERVICE_OPTION_OTHER_DETAIL_PLACEHOLDER')"
        >
          <textarea
            class="form-control"
            rows="2"
            v-model="cafeteria.service_option_other"
            :placeholder="$t('CAFETERIAS.SERVICE_OPTION_OTHER_DETAIL_PLACEHOLDER')"
            @change="onFormChanged"
          ></textarea>
        </base-input>
        <validation-error :errors="apiValidationErrors.service_option_other" />
      </div>
    </div>

    <base-checkbox
      v-model="cafeteria.has_warehouse"
      class="mb-3"
      @change="
        () => {
          onFormChanged();
        }
      "
    >
      <span class="form-control-label">
        {{ $t("COMMON.HAS_WAREHOUSE") }}
      </span>
    </base-checkbox>

    <base-checkbox
      v-model="cafeteria.has_folder"
      class="mb-3"
      @change="
        () => {
          onFormChanged();
        }
      "
    >
      <span class="form-control-label">
        {{ $t("COMMON.HAS_FOLDER") }}
      </span>
    </base-checkbox>

    <!-- General note -->
    <div class="row">
      <div class="col">
        <base-input
          :label="`${$t('CAFETERIAS.NOTE')}`"
          :placeholder="$t('CAFETERIAS.NOTE')"
        >
          <html-editor v-model="cafeteria.excerpt" @change="onFormChanged()">
          </html-editor>
        </base-input>
        <validation-error :errors="apiValidationErrors.excerpt" />
      </div>
    </div>

    <div class="my-4">
      <base-button
        type="button"
        class="btn btn-sm btn-primary"
        native-type="submit"
        :disabled="loading"
      >
        <i class="fas fa-spinner fa-spin" v-if="loading" />
        {{
          cafeteria.id
            ? $t("CAFETERIAS.EDIT_CAFETERIA")
            : $t("CAFETERIAS.ADD_CAFETERIA")
        }}
      </base-button>
    </div>
  </form>
</template>
<script>
import { cloneDeep } from "lodash";
import { Select, Option } from "element-ui";
import formMixin from "@/mixins/form-mixin";
import ValidationError from "@/components/ValidationError.vue";
import BaseInput from "@/components/Inputs/BaseInput.vue";
import HtmlEditor from "@/components/Inputs/HtmlEditor";
import CafeteriaSelector from "@/components/CafeteriaSelector";
import OrganizationSelector from "@/components/OrganizationSelector.vue";
import EstablishmentSelector from "@/components/EstablishmentSelector.vue";
import { SERVICE_TYPES } from "@/constants/cafeteria";
import { 
  ORDER_TYPES, 
  ORDER_TYPE_ONLINE, 
  ORDER_TYPE_COUNTER,
  COUNTER_SERVICE_TYPES,
  SERVICE_OTHER,
  OPERATION_TYPES,
  OPERATION_TYPE_SATELLITE,
  OPERATION_TYPE_PRODUCTION
} from "@/constants/cafeteria";
import {
  discountTypes,
  DISCOUNT_TYPE_PERCENTAGE,
} from "@/constants/establishmentInternalOrders";

export default {
  layout: "DashboardLayout",

  components: {
    BaseInput,
    HtmlEditor,
    CafeteriaSelector,
    ValidationError,
    OrganizationSelector,
    EstablishmentSelector,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  mixins: [formMixin],

  props: [
    "cafeteriaData",
    "formErrors",
    "loading",
    "hideOrganization",
    "hideSubmit",
  ],

  data() {
    const me = this.$store.getters["profile/me"];
    const cafeteriaData = { ...this.cafeteriaData };
    if (this.$currentUserIsLevelOrganization()) {
      cafeteriaData.organization.id = me.organization.id;
    }
    
    // Initialize new fields if they don't exist
    if (!cafeteriaData.order_type) {
      cafeteriaData.order_type = null;
    }
    
    if (!cafeteriaData.service_options) {
      cafeteriaData.service_options = [];
    }

    if (!cafeteriaData.service_option_other) {
      cafeteriaData.service_option_other = null;
    }

    if (!cafeteriaData.excerpt) {
      cafeteriaData.excerpt = null;
    }

    if (!Array.isArray(cafeteriaData.internal_order_discounts)) {
      cafeteriaData.internal_order_discounts = [];
    }
    const existingDiscount = cafeteriaData.internal_order_discounts[0] || {};

    return {
      cafeteria: cafeteriaData,
      internalOrderDiscount: {
        name: existingDiscount.name || null,
        type: existingDiscount.type || DISCOUNT_TYPE_PERCENTAGE,
        value: existingDiscount.value ?? null,
      },
      DISCOUNT_TYPES: discountTypes,
      DISCOUNT_TYPE_PERCENTAGE,
      ORDER_TYPES,
      ORDER_TYPE_ONLINE,
      ORDER_TYPE_COUNTER,
      COUNTER_SERVICE_TYPES,
      SERVICE_OTHER,
      OPERATION_TYPES,
      OPERATION_TYPE_SATELLITE,
      OPERATION_TYPE_PRODUCTION,
      SERVICE_TYPES,
    };
  },

  created() {},

  methods: {
    async handleSubmit() {
      const cafeteriaData = cloneDeep(this.cafeteria);
      if (
        cafeteriaData.operation_type !== OPERATION_TYPE_SATELLITE ||
        !cafeteriaData.productionCafeteria?.id
      ) {
        // Send an explicit `null` (jsona → `data: null`) so the API dissociates
        // any former production cafeteria. Deleting the key would leave the
        // stale link in place, since the API treats an absent relationship as
        // "unchanged".
        cafeteriaData.productionCafeteria = null;
      }
      this.$emit("cafeteriaSubmitted", cafeteriaData);
    },

    onFormChanged() {
      this.$emit("formChanged");
    },

    cafeteriaOperationChange() {
      if (this.cafeteria.operation_type !== OPERATION_TYPE_SATELLITE) {
        this.cafeteria.productionCafeteria.id = null;
      }
      // The rebate only makes sense on a production cafeteria; one without a
      // configured rebate starts at the 50 % default (mirrors the API).
      if (this.cafeteria.operation_type !== OPERATION_TYPE_PRODUCTION) {
        this.cafeteria.internal_order_discounts = [];
        this.internalOrderDiscount = {
          name: null,
          type: DISCOUNT_TYPE_PERCENTAGE,
          value: null,
        };
      } else if (!(this.cafeteria.internal_order_discounts || []).length) {
        this.cafeteria.internal_order_discounts = [
          {
            name: "RABAIS",
            type: DISCOUNT_TYPE_PERCENTAGE,
            value: 50,
          },
        ];
        this.syncInternalOrderDiscountDraft();
      }
    },

    internalOrderDiscountChanged() {
      const value = Number(this.internalOrderDiscount.value || 0);
      this.cafeteria.internal_order_discounts =
        value > 0
          ? [
              {
                name: this.internalOrderDiscount.name || "RABAIS",
                type: this.internalOrderDiscount.type,
                value,
              },
            ]
          : [];
      this.onFormChanged();
    },

    syncInternalOrderDiscountDraft() {
      const existing = (this.cafeteria.internal_order_discounts || [])[0] || {};
      this.internalOrderDiscount = {
        name: existing.name || null,
        type: existing.type || DISCOUNT_TYPE_PERCENTAGE,
        value: existing.value ?? null,
      };
    },
    
    orderTypeChanged() {
      // Clear service options if switched to online order
      if (this.cafeteria.order_type === ORDER_TYPE_ONLINE) {
        this.cafeteria.service_options = [];
        this.cafeteria.service_option_other = null;
      }
      this.onFormChanged();
    },
  },

  watch: {
    formErrors(errors) {
      if (errors) {
        this.setApiValidation(errors);
      }
    },
    cafeteriaData(cafeteriaData) {
      if (cafeteriaData) {
        cafeteriaData = {
          ...cafeteriaData,
          establishment: cafeteriaData?.establishment?.id
            ? cafeteriaData?.establishment
            : { type: "establishments", id: null },
          productionCafeteria: cafeteriaData?.productionCafeteria?.id
            ? cafeteriaData?.productionCafeteria
            : this.cafeteria?.productionCafeteria,
        };
        this.cafeteria = {
          ...this.cafeteria,
          ...cloneDeep(cafeteriaData),
        };
        if (!Array.isArray(this.cafeteria.internal_order_discounts)) {
          this.cafeteria.internal_order_discounts = [];
        }
        this.syncInternalOrderDiscountDraft();
      }
    },
  },
};
</script>
